<script>
import Layout from "../../../layouts/manage";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard",
      items: [""]
    };
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('navbar.dropdown.user.list.settings')" :items="items" />
    <div class="row">

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-briefcase-alt font-size-20 align-middle me-2"></i>
              {{$t('manage.service-and-utility')}}
            
            </h4>
            <div class="card-text mb-2"><router-link :to="'setting/service'">{{$t('manage.service.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/service-type'">{{$t('manage.service.type')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/utility'">{{$t('manage.utility.text')}}</router-link></div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-user font-size-20 align-middle me-2"></i>
              {{$t('manage.customer-or-tenant')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'setting/room-status'">{{$t('manage.rent.status')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'setting/deposit-type'">{{$t('manage.deposit.type')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-money font-size-20 align-middle me-2"></i>
              {{$t('manage.penalty-setting.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'/manage/setting/penalty-setting'">{{$t('setting.manage.penalty')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="report-title mb-4">
              <i class="bx bx-dollar-circle font-size-20 align-middle me-2"></i>
              {{$t('menuitems.profitlost.text')}}
            </h4>
            <div class="card-text mb-2"><router-link :to="'/manage/setting/expense-category'">{{$t('manage.expense-category.text')}}</router-link></div>
            <div class="card-text mb-2"><router-link :to="'/manage/setting/income-category'">{{$t('manage.income-category.text')}}</router-link></div>
            <div class="card-text mb-2" style="color: white">report</div>
            <div class="card-text mb-2" style="color: white">report</div>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
